import { DateTime } from "luxon";

export class AllowedMonthPeriod{
    monthName: string = "";
    monthValue: number = 1;
}

export const GetAllowedPeriods = ((currentSelectedLanguage : string) => {

    if(currentSelectedLanguage != "fr" && currentSelectedLanguage != "nl" && currentSelectedLanguage != "en")
    {
        currentSelectedLanguage = "en";
    }

    var currentLocalizedDate = DateTime.now().setLocale(currentSelectedLanguage);
    
    // current month
    var currentMonth = currentLocalizedDate.monthLong;
    var currentMonthPeriod = new AllowedMonthPeriod();
    currentMonthPeriod.monthName = capitalize(currentMonth);
    currentMonthPeriod.monthValue = currentLocalizedDate.month;

    // month - 1
    var previousMonth = currentLocalizedDate.minus({months: 1});
    var previousMonthPeriod = new AllowedMonthPeriod();
    previousMonthPeriod.monthName = capitalize(previousMonth.monthLong);
    previousMonthPeriod.monthValue = previousMonth.month;

    // month - 2
    var previousMonth2 = currentLocalizedDate.minus({months: 2});
    var previousMonthPeriod2 = new AllowedMonthPeriod();
    previousMonthPeriod2.monthName = capitalize(previousMonth2.monthLong);
    previousMonthPeriod2.monthValue = previousMonth2.month;

    // array
    var monthlyPeriods = new Array<AllowedMonthPeriod>();
    monthlyPeriods.push(currentMonthPeriod);

    if(currentMonthPeriod.monthValue >= 2)
    {
        monthlyPeriods.push(previousMonthPeriod);
    }

    if(currentMonthPeriod.monthValue >= 3)
    {
        monthlyPeriods.push(previousMonthPeriod2);
    }

    return monthlyPeriods;
});

const capitalize = (s : string ) => 
{
    return (s && s[0].toUpperCase() + s.slice(1)) || "";
}